if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialogCustom {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // showActiveMedia() {
      //   this.querySelectorAll(
      //     `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      //   ).forEach((element) => {
      //     element.classList.remove('active');
      //   });
      //   const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      //   const activeMediaTemplate = activeMedia.querySelector('template');
      //   const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      //   activeMedia.classList.add('active');
      //  console.log("data-media",document.querySelector('.pdp-carousel-image.slick-slide.slick-current.slick-active'));
      //   console.log("data-media",parseInt(document.querySelector('.pdp-carousel-image.slick-slide.slick-current.slick-active').getAttribute('data-slick-index')));
      //   // swiper15.slideTo(parseInt(activeMedia.parentElement.getAttribute('data-slick-index'))+1);
      //   $('.slick-carousel').slick('slickGoTo', parseInt(document.querySelector('.pdp-carousel-image.slick-slide.slick-current.slick-active').getAttribute('data-slick-index')))
      //   // activeMedia.scrollIntoView();

      //   const container = this.querySelector('[role="document"]');
      //   container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      //   if (
      //     activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      //     activeMediaContent &&
      //     activeMediaContent.querySelector('.js-youtube')
      //   )
      //     activeMedia.loadContent();
      // }
      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');

        const slide = this.querySelector(
          `.slick-carousel [data-media-id="${mediaId}"]`
        );

        if (!slide) return;

        const slickIndex = $(slide)
          .closest('.slick-slide')
          .data('slick-index');

        $('.slick-carousel').slick('slickGoTo', slickIndex);
      }
    }
  );
}
